import _axios from "../../libs/axios";
import _moment from "../../libs/moment";
import { NotificationManager } from "../../components/common/react-notifications";
import CustomPreviewWhatsApp from "../../components/utils/CustomPreviewWhatsApp";

export default (context) => {
  const M = "admNotification."
  let ctxForm = null
  let ctxSubFormDetailGrid = null
  let dataWasPosted = false
  const onCreateSuccess = (r) => {
    dataWasPosted = true
    context.props.setLoader(false)
    // Store the fetchId after first create
    if (r.data && !context.state.fetchId) {
      context.setState({fetchId: r.data.ID || r.data})
    }
    if (context.state.form.flags.currentStepId === "step-5") {
      if (context.state.previewMode) {
        context.state.previewMode = false
        const formFields = context.state.formFields
        const wizard = formFields.find(f => f.name === "wizard")
        const step5 = wizard.steps.find(s => s.id === "step-5")
        const previewResultField = step5.fields.find(f => f.name === "previewResult")
        if (previewResultField) {
          context.setState({
            form: {
              ...context.state.form,
              previewResult: r.msg
            }
          })
        }
      } else {
        context.getDataById(context.state.fetchId, false)
      }
    }
  }
  const onEditSuccess = (r) => {
    dataWasPosted = true
    context.props.setLoader(false)
    if (context.state.form.flags.currentStepId === "step-5" && context.state.previewMode) {
      context.state.previewMode = false
      context.setState({
        form: {
          ...context.state.form,
          previewResult: r.msg
        }
      })
    }
  }
  const changeTemplate = (ctx) => {
    context.props.setLoader(true)
    _axios
      .get(`admLocalization/get/${ctx.state.doWATemplate.value}?objectType=fetch&objectId=${context.state.idItemSelected || context.state.fetchId}`)
      .then(r => {
        context.props.setLoader(false)
        if (r.status >= 0) {
          const fields = []
          const template = r.data
          template.tagsContent.forEach((t, i) => {
            const hasArtUrl = !!ctx.state.artUrl
            if (t.id === "fetch.title") ctx.setState({[t.id]: ctx.state.name})
            else if (t.id === "fetch.desc") ctx.setState({[t.id]: ctx.state.desc})
            else if (t.id === "header.image") ctx.setState({[t.id]: hasArtUrl ? ctx.state.artUrl : ""})
            else if (ctx.state.placeholders?.length > 0) { ctx.setState({[t.id]: ctx.state.placeholders[i]?.name ?? t.defValue }) }
            else ctx.setState({[t.id]: t.defValue ?? ""})
            if (t.id === "header.image") {
              fields.push(
                {
                  col: 12,
                  name: t.id,
                  value: "",
                  type: "dropzone",
                  label: "",
                  isDoc: false,
                  rules: 'ext:jpeg,jpg,png',
                  placeholder: "main.selectFile",
                  opts: {
                    path: ()=> "/admNotification/file",
                    accept: '.jpeg,.jpg,.png',
                    url: hasArtUrl ? ctx.state.artUrl : ""
                  }
                }
              )
            } else {
              fields.push(
                {
                  col: 6,
                  name: t.id,
                  value: "",
                  type: t.hidden || (["fetch.title", "fetch.desc"].indexOf(t.id) > -1) ? "hidden" : "text",
                  label: t.label || t.id,
                  opts: {
                    style: 'float-label'
                  },
                  disabled: t.readonly
                }
              )
            }
          })
          
          ctx.setState({ selectedTemplate: r.data }, () => {
            const formFields = context.state.formFields
            let wizard = formFields.find(f => f.name === "wizard")
            wizard.steps[0].fields.find(f => f.name === "placeholders").childs = fields
            formFields[0] = wizard
            context.setState({formFields: formFields})
          })
        } else NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
      }).catch(e => context.props.setLoader(false))
  }

  return {
    config: {
      resource: "admNotification",
      pageSize: 40,
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "type",
          value: "w",
          type: "hidden"
        },
        {
          col: 3,
          name: "status",
          value: 0,
          type: "select",
          label: "main.status",
          opts: {
            style: 'float-label',
            items: [
              {
                value: -1,
                label: "main.all"
              },
              {
                value: 0,
                label: `${M}draft`
              },
              {
                value: 1,
                label:  `${M}noSent`
              },
              {
                value: 2,
                label: `${M}sending`
              },
              {
                value: 3,
                label: `${M}sent`
              },
              {
                value: 5,
                label: `${M}paused`
              },
              {
                value: -1,
                label: `${M}seeErrors`
              }
            ]
          }
        }
      ],
      buttons: [
        {
          label: 'main.applyFilter',
          renderIf: (ctx) => true,
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      handleSaveChanges: () => {
        context.state.idItemSelected ? context.edit() : context.create()
      },
      remapOne: (r) => {
        if (r.status >= 0) {
          const { recipientType, groupId, groupName, doWATemplate, doWATemplateName, tags, recurrence, objectId, flowName,sendOn } = r.data
          const tagsArray = tags ? tags.split(",") : []
          
          // Parse cron expression if exists
          let enableRecurrence = false
          let recurrencePattern = "daily"
          let recurrenceDaysArray = []
          let recurrenceMonthsArray = []
          
          if (recurrence) {
            enableRecurrence = true
            const cronParts = recurrence.trim().split(/\s+/)
            
            if (cronParts.length === 5) {
              const [, , day, month, dayOfWeek] = cronParts
              
              // Check if it's a daily pattern (day and month are *, dayOfWeek has values)
              if (day === "*" && month === "*" && dayOfWeek !== "*") {
                recurrencePattern = "daily"
                recurrenceDaysArray = dayOfWeek.split(",").map(d => ({
                  value: parseInt(d),
                  label: _moment().day(parseInt(d)).format('dddd')
                }))
              }
              // Check if it's a monthly pattern (dayOfWeek is *, day has value, month has values)
              else if (dayOfWeek === "*" && day !== "*" && month !== "*") {
                recurrencePattern = "monthly"
                recurrenceMonthsArray = month.split(",").map(m => ({
                  value: parseInt(m),
                  label: _moment().month(parseInt(m) - 1).format('MMMM')
                }))
              }
            }
          }
          
          r.data = {
            ...r.data,
            recipientType: recipientType?.toString() || "0",
            selectedRecipientType: recipientType?.toString() || "0",
            selectedTriggerType: (sendOn && _moment(sendOn).isValid()) ? "date" : "now",
            triggerType: (sendOn && _moment(sendOn).isValid()) ? "date" : "now",
            objectId: objectId ? { value: objectId, label: flowName } : "",
            groupId: groupId ? { value: groupId, label: groupName } : "",
            doWATemplate: doWATemplate ? { value: doWATemplate, label: doWATemplateName } : "",
            tags: tagsArray,
            enableRecurrence: enableRecurrence,
            recurrencePattern: recurrencePattern,
            recurrenceDays: recurrenceDaysArray,
            recurrenceMonths: recurrenceMonthsArray
          }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (!context.state.idItemSelected) v.templateId = v.select1 ?? v.select2 ?? v.select3 ?? v.select4 ?? 0
        v.recipientType = +v.recipientType || 0
        v.groupId = v.groupId?.value ?? v.groupId

        // Set name first, before extracting values
        v.name = v.objectId?.label && v.doWATemplate?.label 
          ? `${v.doWATemplate.label} - ${v.objectId.label}` 
          : "New intelligent outbound"
        // Then extract the values  
        v.objectId = v.objectId?.value ?? v.objectId
        // ... rest of code
        v.doWATemplate = v.doWATemplate?.value
        v.step= (() => {
          const wizard = context.view?.form?.fields.find(f => f.type === "wizard")
          if (wizard) return wizard.steps.find(s => s.id === v.flags.currentStepId).name
        })()
        const tagsContent = v.selectedTemplate?.tagsContent
        let placeholders = []
        if (v.selectedTemplate?.tagsContent) {
          tagsContent.forEach(t => {
            placeholders.push({ID: t.id, name: v[t.id] || ""})
          })
          v.placeholders = placeholders
        }

        // Handle recurrence fields - generate cron expression
        if (v.enableRecurrence && v.sendOn) {
          const sendOnMoment = _moment(v.sendOn)
          const minute = sendOnMoment.format("m")
          const hour = sendOnMoment.format("H")
          
          if (v.recurrencePattern === "daily" && v.recurrenceDays && v.recurrenceDays.length > 0) {
            // Daily pattern: minute hour * * days
            const days = v.recurrenceDays.map(d => d.value || d).join(",")
            v.recurrence = `${minute} ${hour} * * ${days}`
          } else if (v.recurrencePattern === "monthly" && v.recurrenceMonths && v.recurrenceMonths.length > 0) {
            // Monthly pattern: minute hour day months *
            const day = sendOnMoment.format("D")
            const months = v.recurrenceMonths.map(m => m.value || m).join(",")
            v.recurrence = `${minute} ${hour} ${day} ${months} *`
          }
          
          if (v.recurrenceEndDate) {
            v.recurrenceEndDate = _moment(v.recurrenceEndDate).format("YYYY-MM-DD")
          }
        } else {
          v.recurrence = null
          v.recurrenceEndDate = null
        }
        
        // Clean up temporary fields
        delete v.enableRecurrence
        delete v.recurrencePattern
        delete v.recurrenceDays
        delete v.recurrenceMonths
        delete v.select1
        delete v.select2
        delete v.select3
        delete v.select4
        delete v.flags
        delete v.selectedField
        delete v.selectedTemplate
        delete v.inputs
        return v
      },
      onCreateSuccess: onCreateSuccess,
      onEditSuccess: onEditSuccess,
      beforeOpenModal: () => {
        return new Promise((resolve) => {
          context.setState({modalPreview: false})
          resolve(true)
        })
      },
      afterCloseModal: () => {
        context.setState({fetchId: null})
        if (dataWasPosted) {
          context.getData()
          dataWasPosted = false
        }
      },
      fields: [
        {
          col: 12,
          name: "wizard",
          value: "step-2",
          type: "wizard",
          saveByStep: true,
          onChange: (stepId) => {
            // Reset preview fields when changing steps
            context.setState({
              form: {
                ...context.state.form,
                previewResult: null,
                previewStatus: null
              },
              hideBtnSave: stepId === "step-5",
              btnCancel: "main.close"
            })
          },
          steps: [
            {
              id: "step-2",
              name: "admNotification.flowAndTemplate",
              desc: "admNotification.flowAndTemplateDesc",
              method: () => context.state.fetchId ? `/admNotification/edit/${context.state.fetchId}` : `/admNotification/create`,
              fields: [
                {
                  name: "artUrl",
                  type: "hidden"
                },
                {
                  col: 12,
                  name: "label2",
                  value: L => `<h3 class="mb-0">${L[`admNotification.flowAndTemplate`]}</h3><span class='text-muted text-small'>${L[`admNotification.flowAndTemplateDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 12,
                  name: "objectId",
                  value: "",
                  type: "select",
                  label: 'admFlow.typeOfFetch',
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    path: "/admFetch/get?pick=true",
                    setOutput: v => { if (v) return {value: v.value, label: v.label} },
                  }
                },
                {
                  col: 12,
                  name: "doWATemplate",
                  value: "",
                  type: "select",
                  label: `${M}whatsAppTemplate`,
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    path: "/admLocalization/get?type=w&pick=true",
                    setOutput: v => { if (v) return {value: v.value, label: v.label} },
                    addon: {
                      append: {
                        buttons: [
                          {
                            disabled: ctxField => !ctxField.state.doWATemplate,
                            name: "main.preview",
                            onClick: () => context.togglePreview()
                          }
                        ]
                      }
                    }
                  },
                  onChange: (ctx) => {
                    if (!ctx.state.doWATemplate) {
                      ctx.setState({selectedTemplate: null})
                      return
                    }
                    changeTemplate(ctx)
                  }
                },
                {
                  col: 12,
                  name: "placeholders",
                  value: [],
                  type: "fieldset",
                  renderIf: ctx => ctx.state.selectedTemplate 
                },
                {
                  name: "page",
                  value: "whatsapp",
                  type: "hidden"
                },
                {
                  name: "type",
                  value: "w",
                  type: "hidden"
                },
                {
                  name: "name",
                  type: "hidden"
                }
              ]
            },
            {
              id: "step-3",
              name: `admNotification.target`,
              desc: `${M}accessibilityDesc`,
              method: () => context.state.fetchId ? `/admNotification/edit/${context.state.fetchId}` : `/admNotification/create`,
              fields: [
                {
                  col: 12,
                  name: "label3",
                  value: L => `<h3 class="mb-0">${L[`${M}accessibility`]}</h3><span class='text-muted text-small'>${L[`${M}accessibilityDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 12,
                  name: "selectedRecipientType",
                  value: "",
                  type: "text",
                  label: "",
                  rules: "required",
                  rulesMessages: {messages: {required: 'Select a type'}},
                  opts: {
                    inputWrapperClassName: "d-none"
                  }
                },
                {
                  col: 12,
                  name: "recipientType",
                  type: "radio",
                  label: `${M}toSpecificNumbers`,
                  opts: {
                    value: "0",
                    desc: `${M}descToSpecificNumbers`,
                  },
                  onClick: (ctx) => {
                    ctx.toogleSubForm(0)
                    ctxForm = ctx
                  },
                  onChange: ctx => ctx.setState({selectedRecipientType: ctx.state.recipientType})
                },
                {
                  col: 12,
                  name: "btnOpenSpecificNumbers",
                  type: "button",
                  label: "main.edit",
                  opts: {
                    wrapperClassName: "d-flex justify-content-end"
                  },
                  onClick: (ctx) => {
                    ctx.toogleSubForm(0)
                    ctxForm = ctx
                  },
                  renderIf: ctx => ctx.state.groupIdOfNotif > 0 && ctx.state.recipientType === "0"
                },
                {
                  col: 12,
                  name: "recipientType",
                  type: "radio",
                  label: `${M}toSpecificGroups`,
                  opts: {
                    value: "1",
                    desc: `${M}descToSpecificGroups`
                  },
                  onChange: ctx => ctx.setState({selectedRecipientType: ctx.state.recipientType})
                },
                {
                  name: "groupIdOfNotif",
                  type: "hidden"
                },
                {
                  col: 6,
                  offset: 6,
                  name: "groupId",
                  value: null,
                  type: "select",
                  label: "main.category",
                  rules: "required",
                  // parent: "recipientType",
                  opts: {
                    style: 'float-label',
                    path: "admGroup/get?staff=0",
                  },
                  renderIf: () => context.state.form?.recipientType === "1"
                }              
              ]
            },
            {
              id: "step-4",
              name: `main.sendFetchWhen`,
              desc: `${M}followupsDesc`,
              method: () => context.state.fetchId ? `/admNotification/edit/${context.state.fetchId}` : `/admNotification/create`,
              fields: [
                {
                  col: 12,
                  name: "label4",
                  value: L => `<h3 class="mb-0">${L[`main.sendFetchWhen`]}</h3><span class='text-muted text-small'>${L[`${M}availabilityDesc`]}</span>`,
                  type: "label"
                },
                {
                  col: 12,
                  name: "selectedTriggerType", // validator only
                  value: "",
                  type: "text",
                  label: "",
                  rules: "required",
                  rulesMessages: {messages: {required: 'Select a trigger type'}},
                  opts: {
                    inputWrapperClassName: "d-none"
                  },
                },
                {
                  col: 12,
                  name: "triggerType",
                  type: "radio",
                  label: `${M}sendNow`,
                  opts: {
                    value: "now",
                    default: "now"
                  },
                  onChange: ctx => ctx.setState({selectedTriggerType: ctx.state.triggerType}),
                },
                {
                  col: 12,
                  name: "triggerType",
                  type: "radio",
                  label: `${M}onADate`,
                  opts: {
                    value: "date"
                  },
                  onChange: ctx => ctx.setState({selectedTriggerType: ctx.state.triggerType}),
                },
                {
                  col: 6,
                  name: "sendOn",
                  value: "",
                  type: "datetime",
                  label: `${M}selectDate`,
                  parent: "triggerType",
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: () => context.state.form?.triggerType === "date"
                },
                {
                  col: 6,
                  name: "enableRecurrence",
                  value: false,
                  type: "switch",
                  label: `${M}enableRecurrence`,
                  renderIf: () => context.state.form?.triggerType === "date"
                },
                {
                  col: 4,
                  name: "recurrencePattern",
                  value: "daily",
                  type: "select",
                  label: `${M}recurrencePattern`,
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    items: [
                      {
                        value: "daily",
                        label: `${M}daily`
                      },
                      {
                        value: "monthly",
                        label: `${M}monthly`
                      }
                    ]
                  },
                  renderIf: () => context.state.form?.triggerType === "date" && context.state.form?.enableRecurrence
                },
                {
                  col: 4,
                  name: "recurrenceDays",
                  value: [],
                  type: "select",
                  label: `${M}selectDays`,
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    isMulti: true,
                    itemsF: () => [
                      { value: 1, label: _moment().day(1).format('dddd') },
                      { value: 2, label: _moment().day(2).format('dddd') },
                      { value: 3, label: _moment().day(3).format('dddd') },
                      { value: 4, label: _moment().day(4).format('dddd') },
                      { value: 5, label: _moment().day(5).format('dddd') },
                      { value: 6, label: _moment().day(6).format('dddd') },
                      { value: 0, label: _moment().day(0).format('dddd') }
                    ]
                  },
                  renderIf: () => context.state.form?.triggerType === "date" && context.state.form?.enableRecurrence && context.state.form?.recurrencePattern === "daily"
                },
                {
                  col: 4,
                  name: "recurrenceMonths",
                  value: [],
                  type: "select",
                  label: `${M}selectMonths`,
                  rules: "required",
                  opts: {
                    style: 'float-label',
                    isMulti: true,
                    itemsF: () => [
                      { value: 1, label: _moment().month(0).format('MMMM') },
                      { value: 2, label: _moment().month(1).format('MMMM') },
                      { value: 3, label: _moment().month(2).format('MMMM') },
                      { value: 4, label: _moment().month(3).format('MMMM') },
                      { value: 5, label: _moment().month(4).format('MMMM') },
                      { value: 6, label: _moment().month(5).format('MMMM') },
                      { value: 7, label: _moment().month(6).format('MMMM') },
                      { value: 8, label: _moment().month(7).format('MMMM') },
                      { value: 9, label: _moment().month(8).format('MMMM') },
                      { value: 10, label: _moment().month(9).format('MMMM') },
                      { value: 11, label: _moment().month(10).format('MMMM') },
                      { value: 12, label: _moment().month(11).format('MMMM') }
                    ]
                  },
                  renderIf: () => context.state.form?.triggerType === "date" && context.state.form?.enableRecurrence && context.state.form?.recurrencePattern === "monthly"
                },
                {
                  col: 4,
                  name: "recurrenceEndDate",
                  value: "",
                  type: "date",
                  label: `${M}recurrenceEndDate`,
                  rules: "required",
                  opts: {
                    style: 'float-label'
                  },
                  renderIf: () => context.state.form?.triggerType === "date" && context.state.form?.enableRecurrence
                },
                {
                  name: "recurrence",
                  type: "hidden"
                },
              ]
            },
            {
              id: "step-5",
              name: "admFlow.summary",
              desc: "admFlow.summaryDesc",
              method: () => context.state.fetchId ? `/admNotification/edit/${context.state.fetchId}` : `/admNotification/create`,
              fields: [
                {
                  col: 12,
                  name: "label5",
                  value: L => `<h3 class="mb-0">${L['admFlow.summary']}</h3><span class='text-muted text-small'>${L['admFlow.summaryDesc']}</span>`,
                  type: "label"
                },
                {
                  name: "previewResult",
                  type: "hidden"
                },
                {
                  col: 12,
                  name: "previewMessageGreen",
                  value: (L, state) => state?.previewResult || "",
                  type: "alert",
                  renderIf: ctx => ctx?.state?.previewResult && ctx?.state?.previewStatus >= 0,
                  opts: {
                    color: "info"
                  }
                },
                {
                  col: 12,
                  name: "previewMessageRed",
                  value: (L, state) => state?.previewResult || "",
                  type: "alert",
                  renderIf: ctx => ctx?.state?.previewResult && ctx?.state?.previewStatus < 0,
                  opts: {
                    color: "danger"
                  }
                },
                {
                  col: 3,
                  name: "btnPreviewOutbound",
                  type: "button",
                  label: "admFlow.previewOutbound",
                  opts: {
                    outline: true,
                    icon: "iconsminds-3d-eyeglasses"
                  },                 
                  renderIf: ctx => !ctx.state.outboundSuccess,
                  onClick: (ctx) => {
                    ctx.validateForm().then(() => {
                      context.props.setLoader(true)
                      const id = context.state.idItemSelected || context.state.fetchId
                      _axios
                        .post(`/admNotification/schedule/${id}`)
                        .then(r => {
                          context.props.setLoader(false)
                          ctx.setState({
                            previewResult: r.msg,
                            previewStatus: r.status
                          })
                        })
                        .catch(e => {
                          context.props.setLoader(false)
                          NotificationManager.error("An error occurred", "Error", 5000, null, null, 'outline')
                        })
                    }).catch(e => {
                      ctx.setState({
                        previewResult: "There was an error.",
                        previewStatus: -1
                      })
                     })
                  }
                },
                {
                  col: 3,
                  name: "btnConfirmOutbound",
                  type: "button",
                  label: "admFlow.confirmOutbound",
                  opts: {
                    icon: "iconsminds-plane",
                  },
                  renderIf: ctx => ctx.state.previewResult && ctx.state.previewStatus >= 0 && !ctx.state.outboundSuccess,
                  onClick: (ctx) => {
                    context.props.setLoader(true)
                    const fetchId = context.state.idItemSelected || context.state.fetchId
                    const endpoint =  `/admNotification/schedule/${fetchId}?confirm=true`
                    _axios
                      .post(endpoint)
                      .then(r => {
                        context.props.setLoader(false)
                        if (r.status >= 0) {
                          ctx.setState({ 
                            outboundSuccess: true,
                            previewResult: null,
                            previewStatus: null
                          })
                          NotificationManager.success(r.msg, "Success", 5000, null, null, 'outline')
                          setTimeout(() => context.toggleModal(), 100)
                        } else {
                          NotificationManager.error(r.msg, "Error", 5000, null, null, 'outline')
                        }
                      })
                      .catch(e => {
                        context.props.setLoader(false)
                        ctx.setState({ outboundSuccess: false })
                      })
                  }
                },
                {
                  col: 3,
                  name: "spacer",
                  type: "spacer"
                }
              ]
            }
          ]
        }
      ],
      subforms: [
        {
          size: "md",
          name: `${M}mobileNumbers`,
          wrapClassName: "mb-4",
          fields: [
            {
              col: 12,
              name: "tabs",
              value: "copyPaste",
              type: "tabs",
              tabs: [
                {
                  id: "copyPaste",
                  name:  `${M}copyPaste`,
                  fields: [
                    {
                      col: 12,
                      name: "phoneList",
                      value: "",
                      type: "textarea",
                      label: `${M}enterMobileNumbers`,
                      placeholder: "Sample:\n+51963214569\n+51969875563\n+51963369852",
                      rules: "required",
                      opts: {
                        rows: "12"
                      }
                    }
                  ]
                },
                {
                  id: "fromCSV",
                  name: `${M}fromCSV`,
                  fields: [
                    {
                      col: 12,
                      name: "btnTemplate",
                      type: "button",
                      label: "main.downloadExcelTemplate",
                      onClick: () => {
                        window.open(`/tplmails/dwn/UsersImport.xlsx`, "_blank")
                      }
                    },
                    {
                      col: 12,
                      name: "data",
                      value: "",
                      type: "dropzone",
                      rules: "required",
                      placeholder: "main.selectFile",
                      opts: {
                        accept: '.csv',
                        output: true
                      }
                    }
                  ]
                }
              ]
            },
            {
              col: 12,
              name: "useGroupLabel",
              value: (L) => `<h5>${L[`${M}useGroup`]}</h5>`,
              type: "label",
            },
            {
              col: 12,
              name: "useGroup",
              value: false,
              type: "switch",
              label: `${M}loadContacts`,
              onChange: ctx => {
                if (!ctx.state.useGroup) ctx.setState({
                  groupId: null,
                  groupName: null
                }, () => {
                  ctxSubFormDetailGrid.setState({data: []})
                })
              }
            },
            {
              col: 6,
              name: "groupId",
              value: null,
              type: "select",
              label: "main.category",
              rules: "required",
              opts: {
                style: 'float-label',
                path: "admGroup/get?staff=0",
                setOutput: v => { if (v) return {value: v.value, label: v.label} },
              },
              onChange: ctx => {
                if (ctx.state.groupId) ctxSubFormDetailGrid.setState({resource: `admUser/group/${ctx.state.groupId.value}`}, () => {
                  ctxSubFormDetailGrid.getData()
                })
                else ctxSubFormDetailGrid.setState({data: []})
              },
              renderIf: ctx => ctx.state.useGroup,
              disabled: ctx => ctx.state.groupName
            },
            {
              col: 6,
              name: "groupName",
              value: "",
              type: "text",
              label: `${M}newGroup`,
              opts: {
                style: "float-label"
              },
              renderIf: ctx => ctx.state.useGroup,
            }
          ],
          buttons: [
            {
              label: `${M}addNumbers`,
              isMain: true,
              onClick: (ctx) => {
                ctx.validateForm().then(() => {
                  context.props.setLoader(true)
                  const fetchId = context.state.idItemSelected || context.state.fetchId
                  const groupIdOfNotif = context.state.form.groupIdOfNotif
                  const body = {
                    data: ctx.state.data?.[0]?.value || null,
                    phoneList: ctx.state.phoneList || null,
                    groupId: ctx.state.groupName ? 0 : (ctx.state.groupId ? ctx.state.groupId.value : groupIdOfNotif),
                    groupName: ctx.state.groupName || (!groupIdOfNotif ? `Unnamed_group_${fetchId}` : null)
                  }

                  _axios
                    .post(`admUser/importAttach`, body)
                    .then(r => {
                      if (r.status === 0) {
                        ctxForm.toogleSubForm(0)
                        if (ctx.state.useGroup) {
                          ctxForm.setState({
                            recipientType: "1", 
                            groupId: ctx.state.groupName
                            ? {value: r.data?.groupId, label: ctx.state.groupName}
                            : {value: ctx.state.groupId.value, label: ctx.state.groupId.label}
                          })
                        } else if (!ctx.state.useGroup && r.data?.groupId) {
                          ctxForm.setState({
                            recipientType: "0",
                            // groupId: {value: r.data.groupId, label: r.data.groupId},
                            groupIdOfNotif: r.data.groupId
                          })
                        }
                      }
                      NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                      context.props.setLoader(false)
                    }).catch(e => context.props.setLoader(false))
                })
                .catch(e => { /* console.log(e) */ })
              }
            }
          ],
          detailGrid: () => {
            return {
              module: 'admUser',
              embeded: (ctx) => {
                ctxSubFormDetailGrid = ctx
                return {
                  config: {
                    pageSize: 40,
                    resource: `admUser/group/${context.state.form?.groupIdOfNotif || 0}`,
                  },
              
                  actions: {
                    delete: true
                  },

                  columns: [
                    {
                      Header: "main.ID",
                      accessor: "ID"
                    },
                    {
                      Header: "main.name",
                      accessor: "name"
                    },
                    {
                      Header: "main.lastName",
                      accessor: "last"  
                    }
                  ]
                }
              }
            }
          }
        },
        {
          size: "md",
          name: `${M}contextRAG`,
          wrapClassName: "mb-4",
          fields: [{
            col: 12,
            name: "label6",
            value: L => `<span class='text-muted text-small'>${L[`${M}contextRAGDesc`]}</span>`,
            type: "label"
          }]
        }
      ]
    },

    columns: [
      {
        Header: "main.name",
        accessor: "name",
        width: 200
      },
      {
        Header: "main.status",
        accessor: "status",
        type: 'chip',
        chips: {
          0: {text: 'Draft', color:'lightgreen'},
          1: {text: 'Ready', color:'lightgreen'},
          2: {text: 'Sending', color:'lightgreen'},
          3: {text: 'Sent', color:'green'},
          4: {text: 'Cancelled', color:'red'},
          5: {text: 'Errors', color:'red'}
        },
        width: 60
      },
      {
        Header: `${M}sendDate`,
        accessor: "sendOn",
        isDate:true,
        width: 140
      },
      {
        Header: 'admFlow.countTarget',
        accessor: "total",
        width: 60
      },
      {
        Header: `${M}sent`,
        accessor: "sent",
        width: 60
      },
      {
        accessor: "sentProgress",
        type:'progress',
        width: 60
      },
      {
        Header: 'admFlow.countSeen',
        accessor: "read",
        width: 50
      },
      {
        accessor: "readProgress",
        type:'progress',
        width: 60
      },
      {
        Header: `${M}failed`,
        accessor: "failed",
        width: 60
      }
    ],

    preview: {
      template: CustomPreviewWhatsApp,
      previewOf: {
        form: {
          name: `main.whatsappMessagePreview`,
          handleData: (data) => {
            if (!data) return
            let msgs = []
            let header = data?.selectedTemplate?.content
            let buttons = []
            let headerImage = null
            const tagsContent = data?.selectedTemplate?.tagsContent
            if (tagsContent) {
              /*
              tagsContent.forEach(t => {
                if (data[t.id]) {
                  content = content.replaceAll(`{{${t.id}}}`, data[t.id])
                }
              })
              */
              tagsContent.forEach((t, index) => {
                const contentValue = data[t.id] || t.defValue
                if (contentValue) {
                  header = header.replaceAll(`{{${index+1}}}`, contentValue)
                }
                if (t.id.includes("button")) {
                  buttons.push(contentValue)
                }
                // Check for header image
                if (t.id === "header.image") {
                  headerImage = contentValue || null
                }
              })
            }
            const m = {
              type: "received",
              content: header,
              buttons: buttons,
              media: headerImage
            }
            msgs.push(m)
            if (data.inputs) {
              msgs = msgs.concat(data.inputs.map(item => item = {type: "received", content: item.name, buttons: item.options ? item.options.split("|") : []}))
            }
            return msgs
          }
        }
      },
      renderIf: () => context.state.form?.selectedTemplate && context.state.form?.flags?.currentStepId === "step-2"
    }
  }
}